import * as moment from "moment";

export const calculateTimeDifference = (wound, parentWound) => {
  const pastDate = parentWound.createdAt;
  let equalOrFutureDate;
  if (parentWound.state === 'active') {
    equalOrFutureDate = new Date();
  } else {
    // equalOrFutureDate = wound.createdAt;
    equalOrFutureDate = parentWound.remission_date;
  }
  
  const days = Math.floor(moment(equalOrFutureDate).diff(pastDate, "hours") / 24);
  const weeks = Math.floor(days / 7);
  const remaining_days = days % 7;
  if (days < 7) {
    if (days <= 1) {
      return `${days} day`;
    } else {
      return `${days} days`;
    }
  } else {
    if (remaining_days === 0) {
      if (weeks === 1) {
        return `${weeks} week`;
      } else {
        return `${weeks} weeks`;
      }
    } else {
      return `${weeks} w ${remaining_days} d`;
    }
  }
  // const weeks = days/7;
  // if (days < 7) {
  // } else {
  //     return `${weeks} weeks`;
  // }
};
export const calculateWeekDifference = (wound) => {
  const pastDate = wound.wound_updation_date ? wound.updated_At : wound.created_At;
  const equalOrFutureDate = new Date();
  const days = Math.floor(moment(equalOrFutureDate).diff(pastDate, "hours") / 24);
  const weeks = Math.floor(days / 7);
  if (days < 7) {
    return 0;
  }else{
    return weeks;
  }
};
export const calculateAreaforBanner = (wound): any => {
  // TODO: write formula
  if (wound?.source?.includes("kent")) {
    if (wound?.area) {
      return Math.round(Number(wound.area));
    } else {
      return 0;
    }
  } else {
    const value = Number(wound.length) * Number(wound.width);
    return Math.round(value);
  }
};
export const calculateVolumeforBanner = (wound): any => {
  // TODO: write formula
  if (wound?.source?.includes("kent")) {
    if (wound?.volume) {
      return Math.round(Number(wound.volume));
    } else {
      const value = Number(wound.area) * Number(wound.depth);
      return Math.round(value);
    }
  } else {
    const value = Number(wound.length) * Number(wound.width) * Number(wound.depth);
    return Math.round(value);
  }
};
export const calculateArea = (wound): any => {
  // TODO: write formula
  if (wound?.source?.includes("kent")) {
    if (wound?.area) {
      return Number(wound.area);
    } else {
      return 0;
    }
  } else {
    const value = Number(wound.length) * Number(wound.width);
    return Number(value.toFixed(4));
  }
};
export const calculateVolume = (wound): any => {
  // TODO: write formula
  if (wound?.source?.includes("kent")) {
    if (wound?.volume) {
      return Number(wound.volume);
    } else {
      if(wound?.area){
        const value = Number(wound.area) * Number(wound.depth);
        return Number(value.toFixed(4));
      }else{
        return 0;
      }
    }
  } else {
    const value = Number(wound.length) * Number(wound.width) * Number(wound.depth);
    return Number(value.toFixed(4));
  }
};
export const getFieldName = (header) => {
  header = header.trim().toLowerCase().replace(/ /g, '_');
  switch (header) {
    case 'wound_type':
      return 'etiolgy'

    case 'location':
      return 'body_part'

    case 'severity':
      return 'stage'

    case 'laterality':
      return 'body_side'

    case 'exposed_tissues':
      return 'exposed_tissues'
  }
  return header;
}